export const HELP_CENTRE = {
  CHARGELAB: 'https://chargelab.zendesk.com/hc/en-us',
  IVY: 'https://ivycharging.zendesk.com/hc/en-ca',
};
